export function addCurrent(priority) {
  return {
      type: 'ADD_CURRENT',
      priority,
  }
}
